export const SET_THEME = 'SET_THEME';